import { useEffect, useState, useRef } from "react";

import ReactPaginate from "react-paginate";
import { jsonParse, useWPAjax } from "../../../../../wp-utils/v1";
import MemberModal from "./MemberModal";
import defaultProfilePicture from "./../../../assets/images/profile_pic.png";
// import "datatables.net-responsive-dt";

import "./../../../assets/css/jquery.dataTables.css";

import "./style.scss";

const Members = ({ auth, members, setState, nonce, refetch, isLoading, page }) => {
  const { isLoading: deleting, refetch: deleteUser } = useWPAjax("ajax_request_handler", { method: "delete_user", model: "Users", nonce }, true);
  const [open, setOpen] = useState(false);
  const [currentItem, setCurrentItem] = useState({});
  const { data: fields = [] } = useWPAjax("ajax_request_handler", { nonce, model: "Users", method: "registration_fields" });
  const [itemOffset, setItemOffset] = useState(0);
  const [currentBatch, setCurrentBatch] = useState(null);
  const [searchQuery, setSearchQuery] = useState(null);
  const [editable, setEditable] = useState(false);

  const [filteredMembers, setFilteredMembers] = useState(members);

  const tableRef = useRef();

  const itemsPerPage = 10;
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = filteredMembers?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filteredMembers?.length / itemsPerPage);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % members.length;
    setItemOffset(newOffset);
  };

  const modalOpen = (index) => {
    setCurrentItem(filteredMembers[itemOffset + index]);

    setTimeout(() => {
      setOpen(true);
    }, 100);
  };

  useEffect(() => {
    if (!deleting) {
      refetch();
    }
  }, [deleting]);

  useEffect(() => {
    const Members = members?.filter((member) => {
      let shouldAdd = true;
      if (currentBatch && member.year_of_ssc_exam !== currentBatch) {
        shouldAdd = false;
      }

      if (searchQuery) {
        shouldAdd = member.full_name_en.toLowerCase().includes(searchQuery.toLowerCase());
      }

      return shouldAdd;
    });

    setFilteredMembers(Members);
  }, [currentBatch, searchQuery, members]);

  return (
    <div>
      <div className="text-center mb-2">
        <h3 className="text-3xl">{page === "member-applications" ? "Pending Applications" : "Members"}</h3>
      </div>
      <div className="relative overflow-x-auto  sm:rounded-lg">
        <div className="member_filter flex">
          <div className="search_filter">
            <input
              onChange={(e) => setSearchQuery(e.target.value)}
              type="text"
              value={searchQuery}
              placeholder="Search for members..."
              className="bg-gray-50 w-52 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              required=""
            />
          </div>
          <div className="batch_filter w-62 z-10">
            <label htmlFor="countries" className="whitespace-nowrap block mb-2 text-sm font-medium text-gray-900">
              Select Batch
            </label>
            <select
              id="countries"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:text-white dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              onChange={(e) => setCurrentBatch(e.target.value)}
            >
              <option value="" selected>
                All Batch
              </option>
              {[...Array(new Date().getFullYear() - 1949)].map((item, index) => (
                <option key={index} value={1950 + index}>
                  {1950 + index}
                </option>
              ))}
            </select>
          </div>
        </div>
        <table ref={tableRef} className="dashboard_member_table mt-3 w-full text-sm text-left text-gray-500 dark:text-gray-400">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="px-3 py-3 text-center">
                SN
              </th>
              <th scope="col" className="px-3 py-3 text-center">
                <span className="block text-center">Photo</span>
              </th>
              <th scope="col" className="px-3 py-3 text-center">
                Name
              </th>
              <th scope="col" className="px-3 py-3 text-center">
                Batch
              </th>
              <th scope="col" className="px-3 py-3 text-center">
                Present Address
              </th>
              <th scope="col" className="px-3 py-3 text-center">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {currentItems?.length > 0 ? (
              currentItems?.map((member, index) => {
                const { full_name_en, email, mobile_no, profession, profile_pic, id, is_approved, year_of_ssc_exam, present_address } = member;
                const { village, district, thana, postOffice } = present_address || {};
                return (
                  <tr key={member.id} className="bg-white border-b dark:bg-gray-900 dark:border-gray-700">
                    <td className="px-3 py-4">{itemOffset + index + 1}</td>
                    <td className="px-3">
                      <img src={profile_pic && profile_pic != "null" ? profile_pic : defaultProfilePicture} alt="" width="80" height="80" />
                    </td>
                    <td className="px-3 py-4 text-gray-900 whitespace-nowrap dark:text-white">
                      <b>{full_name_en}</b> <br />
                      {profession}
                      <br />
                      {email} <br />
                      {mobile_no}
                    </td>
                    <td className="px-3 py-4">{year_of_ssc_exam}</td>
                    <td className="px-3 py-4">
                      {village + ", " + postOffice} <br /> {thana + ", " + district}
                    </td>
                    <td className="px-3 py-4">
                      <button
                        onClick={() => modalOpen(index)}
                        disabled={deleting || isLoading}
                        className="ml-2 border-none font-medium text-white bg-gray-700 px-2 py-1 rounded hover:text-white hover:bg-gray-800 disabled:opacity-50"
                      >
                        View
                      </button>

                      {["administrator"].includes(auth?.role) && (
                        <button
                          onClick={() => {
                            setEditable(true);
                            modalOpen(index);
                          }}
                          disabled={deleting || isLoading}
                          className="ml-2 border-none font-medium text-white bg-red-700 px-2 py-1 rounded hover:text-white hover:bg-red-800 disabled:opacity-50"
                        >
                          Edit
                        </button>
                      )}
                      {!is_approved && ["administrator", "admin"].includes(auth?.role) && (
                        <button
                          onClick={() => {
                            const confirm = window.confirm("Are you sure you want to delete?");
                            if (confirm) {
                              deleteUser({ id });
                            }
                          }}
                          disabled={deleting || isLoading}
                          className="ml-2 border-none font-medium text-white bg-red-700 px-2 py-1 rounded hover:text-white hover:bg-red-800 disabled:opacity-50"
                        >
                          Delete
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })
            ) : isLoading ? (
              ""
            ) : (
              <tr>
                <td colSpan={6} className="text-center">
                  <h3>No Member Found</h3>
                </td>
              </tr>
            )}
            {isLoading && (
              <tr className="text-center">
                <td colSpan={6}>Loading...</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {filteredMembers?.length > itemsPerPage && (
        <ReactPaginate
          breakLabel="..."
          nextLabel="Next"
          className="pagination"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="Previous"
          renderOnZeroPageCount={null}
        />
      )}
      <MemberModal
        refetch={refetch}
        auth={auth}
        page={page}
        open={open}
        setOpen={setOpen}
        member={currentItem}
        nonce={nonce}
        setState={setState}
        editable={editable}
        setEditable={setEditable}
        fields={jsonParse(fields)?.filter((item) => !["email", "password"].includes(item.name))}
      />
    </div>
  );
};

export default Members;
